// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_AuthUrlInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /instagram/accounts/auth_url
 *
 * No body required — endpoint builds the OAuth URL from server-side config.
 */
import { registerContract } from './validate'

export interface InstagramAccounts_AuthUrlInput {}

registerContract('InstagramAccounts_AuthUrlInput', {})
